import { createFileRoute } from "@tanstack/react-router";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { PatientPreferencesForm } from "@/components/patient/preferences/patient-preferences-form";
import { useGraphQL } from "@/hooks/use-graphql.ts";

import type { JSX } from "react";

const PatientPreferencesPageQuery = graphql(/* GraphQL */ `
  query PatientPreferencesPageQuery {
    ...PatientPreferencesFormFragment
  }
`);

const PatientPreferencesPage = (): JSX.Element => {
  const queryResult = useGraphQL(PatientPreferencesPageQuery, {});
  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Pacientes" align="center" />
      </HeaderRoot>
      <Page className="px-6 py-8">
        <AsyncDataWrapper {...queryResult}>
          {data ? <PatientPreferencesForm data={data} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/service-preferences/edit/patient-preferences",
)({
  component: PatientPreferencesPage,
});
